import React from "react";

export default function ExhibitionsPage() {
  return <div>This is a work in progress!</div>;
}
